import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'TextContent',
  props: {
    padding: { type: Boolean },
    extraPadding: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ [_ctx.$style.content]: true, [_ctx.$style.padding]: __props.padding, [_ctx.$style.extraPadding]: __props.extraPadding })
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})